import { InjectionToken } from "@angular/core";

// Create the injection token for the custom settings
export const API_CONFIG = new InjectionToken('redApiConfig');
